import { render, staticRenderFns } from "./add-theme.vue?vue&type=template&id=7e3c4aa4&"
import script from "./add-theme.vue?vue&type=script&lang=ts&"
export * from "./add-theme.vue?vue&type=script&lang=ts&"
import style0 from "./add-theme.vue?vue&type=style&index=0&id=7e3c4aa4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports